import React, { useContext, useRef, useState } from "react";

import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { Checkbox } from "primereact/checkbox";
import { confirmDialog } from "primereact/confirmdialog";
import { cambiarEstadoRevisado, cambiarRecibidoCompras, cambiarRecibidofinanzas } from "../../../../API/Suministros/IngresosBodega/IngresosBodegaDetalleRequest";
import { toastShow } from "../../../../Base/Services/ToastService";
import { Toast } from "primereact/toast";

const ListadoIngresosBodega = ({
  listadoEnc,
  loading,
  setIngresoEdit,
  setShowDialog,
  selectedDetalle,
  setSelectedDetalle,
  verCostosBodega,
  reg,
  getInfo
}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [verCostos, setVerCostos] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(49) || userAuth.IdRol == 1);
  const [hiddenPriceColumn, setHiddenPriceColumn] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(29));

    const changeRevisado = async (datos, e) => {
      if (datos) {
        confirmDialog({
          message: `¿Está seguro que desea revisar ${selectedDetalle.length > 1 ? "los ingresos" : "el ingreso"}?`,
          header: "Confirmación",
          icon: "pi pi-exclamation-triangle",
          accept: async () => {
            let ids = selectedDetalle.filter((item) => item.IdEstadoRevisado === 74 || item.IdEstadoRevisado === 75).map((item) => item.IdIngreso);
            // let ids = selectedDetalle.map((item) => item.IdIngreso);
            let idsDetalles = ids.join(",") || datos?.IdIngreso;
            //ROL FINANZAS , ADMIN
            if(userAuth?.IdRol === 36 || userAuth?.IdRol === 1){
              const respuestaDetalles = await cambiarEstadoRevisado(idsDetalles);
              toastShow(toast, "success", "Editado", "Registros recibidos.");
              getInfo()
            }else{
              toastShow(toast, "warn", "Adverencia", "Permisos no autorizados.");
            }
          },
          reject: () => {},
        });
      
      }
      setSelectedDetalle([]);
    };

    //FINANZAS
    const changeRecibidoFinanzas = async (datos, e) => {
      if (datos) {
        confirmDialog({
          message: `¿Está seguro que desea recibir ${selectedDetalle.length > 1 ? "los registros" : "el registro"}?`,
          header: "Confirmación",
          icon: "pi pi-exclamation-triangle",
          accept: async () => {
            let ids = selectedDetalle.filter((item) => item.IdEstadoRevisado === 73 || item.IdEstadoRevisado === 74).map((item) => item.IdIngreso);
            let idsDetalles = ids.join(",") || datos?.IdIngreso;
            //ROL FINANZAS , ADMIN
            if(userAuth?.IdRol === 36 || userAuth?.IdRol === 1){
              const respuestaDetalles = await cambiarRecibidofinanzas(idsDetalles, userAuth?.IdUser);
              toastShow(toast, "success", "Editado", "Registros recibidos.");
              getInfo()
            }else{
              toastShow(toast, "warn", "Adverencia", "Permisos no autorizados.");
            }
          },
          reject: () => {},
        });
      
      }
      setSelectedDetalle([]);
    };

    //COMPRAS
    const changeRecibidoCompras = async (datos, e) => {
      if (datos) {
        confirmDialog({
          message: `¿Está seguro que desea recibir ${selectedDetalle.length > 1 ? "los registros" : "el registro"}?`,
          header: "Confirmación",
          icon: "pi pi-exclamation-triangle",
          accept: async () => {
            let ids = selectedDetalle.filter((item) => item.IdEstadoRevisado === 73 || item.IdEstadoRevisado === 76).map((item) => item.IdIngreso);
            let idsDetalles = ids.join(",") || datos?.IdIngreso;
            //ROL COMPRAS , ADMIN
            if(userAuth?.IdRol === 25 || userAuth?.IdRol === 1){
              const respuestaDetalles = await cambiarRecibidoCompras(idsDetalles);
              toastShow(toast, "success", "Editado", "Registros revisados.");
              getInfo()
            }else{
              toastShow(toast, "warn", "Adverencia", "Permisos no autorizados.");
            }
          },
          reject: () => {},
        });
      
      }
      setSelectedDetalle([]);
    };

  const columns = [
    {
      // Comment
      field: "IdIngreso",
      header: "ID",
      headerEn: "ID",
      className: "colum-width-Xlarge",
      body: (rowData) => rowData.IdIngreso,
      frozen: "frozen",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      // FechaPermiso4
      field: "FechaIngreso",
      header: "Fecha de Ingreso",
      headerEn: "Date Create",
      className: "colum-width-medium",
      body: (rowData) => rowData.DateCreated,
      align: "center",
      Format: "DateTime2",
      frozen: "frozen",
    },
    {
      // ESTADO
      field: "StatusName",
      header: "Estado",
      headerEn: "Status",
      className: "small",
      body: (rowData) => ({
        ID: rowData.IdEstado,
        Estado: rowData.StatusName,
      }),
      frozen: "frozen",
      alignFrozen: "left",
      Format: "Estado",
    },
    {
      // PurchaseRequest
      field: "NumeroIngreso",
      headerEn: "Entry Number",
      header: "No. Ingreso",
      className: "small",
      body: (rowData) => rowData.NumeroIngreso,
      Format: "Modal",
      align: "center",
      Sumary: "count",      
      frozen: "frozen",
      onCellDoubleClicked: ({ data }) => {
        Ingreso(data.NumeroIngreso);
      },
    },
    reg ?
    {
      // Comment
      field: "Inventario",
      header: "Tipo Ingreso",
      headerEn: "Income Type",
      className: "small",
    } : null,
    {
      // ESTADO
      field: "EstadoRevisado",
      header: "Revisado",
      headerEn: "Revised",
      className: "small",
      body: (rowData) => ({
        ID: rowData.IdEstadoRevisado,
        Estado: rowData.EstadoRevisado,
      }),
      Format: "Estado",
    },
    {
      // PurchaseRequest
      field: "PurchaseOrder",
      headerEn: "PO",
      header: "OC",
      className: "small",
    },
    {
      // SolicitaN
      field: "Comentarios",
      header: "Comentario",
      headerEn: "Comment",
      className: "colum-width-large",
      body: (rowData) => rowData.Comentarios,
    },
    {
      // Proveedor
      field: "Factura",
      header: "Factura",
      headerEn: "Bill",
      className: "colum-width-large",
      body: (rowData) => rowData.Factura,
    },
    {
      // Comment
      field: "FechaFactura",
      header: "Fecha Factura",
      headerEn: "Fecha Factura",
      body: (rowData) => rowData.FechaFactura,
      className: "small",
    },
    {
      // Proveedor
      field: "CustomerName",
      header: "Proveedor",
      headerEn: "Supplier",
      className: "large",
      body: (rowData) => rowData.IdVendor,
    },
    {
      // Proveedor
      field: "Term",
      header: "Término de Compra",
      headerEn: "Payment Term",
      className: "Xsmall",
    },
    // {
    //   // Comment
    //   field: "IdLiquidacionContable",
    //   header: "IdLiquidacionContable",
    //   headerEn: "IdLiquidacionContable",
    //   className: "colum-width-Xlarge",
    //   body: (rowData) => rowData.IdLiquidacionContable,
    // },
    {
      // Comment
      field: "UserNameIngreso",
      header: "Usuario Ingreso",
      headerEn: 'User Login',
      className: "small",
      body: (rowData) => rowData.UserNameIngreso,
    },
    {
      // Comment
      field: "UserNameEdit",
      header: "Usuario Edit",
      headerEn: "User Edit",
      className: "small",
      hidden: userAuth.IdRol === 1,
      body: (rowData) => rowData.UserNameEdit,
    },

    {
      field: "IsDollar", 
      header: "IsDollar", 
      headerEn: "IsDollar", 
      className: "Xsmall",  
      align: 'center', 
      Format: "Template", 
      filter: false,
      body: (rowData) => {
        return (
          rowData.IdIngreso ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '2px' }}>
            <Checkbox
              checked={rowData.IsDollar === true}
            />
          </div> : null
        );
      }
    },

    {
      headerName: 'Embalaje',
      hidden: userAuth?.IdRol === 1,
      children: [
        {
          field: "EmbalajeL",
          header: "Monto L",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto L",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
        },
        {
          field: "EmbalajeD",
          header: "Monto $",
          hidden: verCostos || verCostosBodega,
          headerEn: "Amount $",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
        },
        {
          field: "TasaCambioEmbalaje",
          header: "Tasa",
          hidden: verCostos || verCostosBodega,
          headerEn: "Tasa",
          Format: "Currency",
          className: "Xsmall",
        },
      ]
    },

    {
      headerName: 'Desaduanaje',
      children: [
        {
          field: "DesaduanajeL",
          header: "Monto L",
          headerEn: "Monto L",
          Format: "Currency",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          className: "Xsmall",
        },
        {
          field: "DesaduanajeD",
          header: "Monto $",
          headerEn: "Amount $",
          Format: "Currency",
          hidden: verCostos || verCostosBodega,
          Sumary: "sum",
          className: "Xsmall",
        },
        {
          field: "TasaCambioDesaduanaje",
          header: "Tasa",
          headerEn: "Tasa",
          hidden: verCostos || verCostosBodega,
          Format: "Currency",
          className: "Xsmall",
        },
      ]
    },

    {
      headerName: 'Flete',
      children: [
        {
          field: "FleteL",
          header: "Monto L",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto L",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
        },
        {
          field: "FleteD",
          header: "Monto $",
          headerEn: "Amount $",
          hidden: verCostos || verCostosBodega,
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
        },
        {
          field: "TasaCambioFlete",
          hidden: verCostos || verCostosBodega,
          header: "Tasa",
          headerEn: "Tasa",
          Format: "Currency",
          className: "Xsmall",
        },
      ]
    },

    {
      headerName: 'OtrosCostos',
      children: [
        {
          field: "OtrosCostosL",
          header: "Monto L",
          headerEn: "Monto L",
          Format: "Currency",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          className: "Xsmall",
        },
        {
          field: "OtrosCostosD",
          header: "Monto $",
          headerEn: "Amount $",
          hidden: verCostos || verCostosBodega,
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
        },
        {
          field: "TasaCambioOtrosCostos",
          header: "Tasa",
          hidden: verCostos || verCostosBodega,
          headerEn: "Tasa",
          Format: "Currency",
          className: "Xsmall",
        },
      ]
    },

    // LEMPIRAS
    {
      headerName: 'Lempiras',
      header: 'Lempiras',
      children: [
        {
          // Comment
          field: "SubTotal",
          header: "SubTotal L",
          headerEn: "SubTotal L",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "ISV",
          header: "ISV",
          Sumary: "sum",
          header: "ISV L",
          headerEn: "TAX L",
          Format: "Currency",
          className: "Xsmall",
          body: (rowData) => rowData.ISV,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "Descuento",
          Sumary: "sum",
          header: "Desc. L",
          headerEn: "Disc. L",
          Format: "Currency",
          className: "Xsmall",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
      ]
    },

    // DOLARES
    {
      headerName: 'Dolares',
      header: 'Dolares',
      children: [
        {
          // Comment
          field: "SubTotalD",
          header: "SubTotal $",
          headerEn: "SubTotal $",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "TAX",
          header: "ISV $",
          headerEn: "TAX $",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          body: (rowData) => rowData.TAX,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "DescuentoD",
          header: "Desc. $",
          headerEn: "Disc. $",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
      ]
    },

    {
      // Comment
      field: "MontoL",
      header: "Monto L",
      headerEn: "Monto L",
      Format: "Currency",
      className: "small",
      body: (rowData) => rowData.Total,
      Sumary: "sum",
      hidden: userAuth.IdRol === 1,
      frozen: true,
      alignFrozen: "right",
      hidden: hiddenPriceColumn,
    },

    {
      // Comment
      field: "MontoD",
      header: "Monto $",
      headerEn: "Monto $",
      Format: "Currency",
      className: "small",
      body: (rowData) => rowData.TotalD,
      Sumary: "sum",
      hidden: userAuth.IdRol === 1,
      frozen: true,
      alignFrozen: "right",
      hidden: hiddenPriceColumn,
    },

    !reg ?
    {
      field: '',
      header: 'Recibido Compras',
      className: "small",
      Format: "Template",
      align: "center",
      frozen: "true",
      alignFrozen: "right",
      filter: false,
      hidden: [1,25].includes(userAuth?.IdRol), //Roles Admin, Compras
      body: (rowData) =>  rowData?.IdIngreso && (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Checkbox 
          onChange={(e) => {
            changeRecibidoCompras(rowData, e.checked)}
          }
          disabled={[74,75].includes(rowData?.IdEstadoRevisado)}
          checked={[73,74,75].includes(rowData?.IdEstadoRevisado)}
        />
      </div>
      ),
    } : null, 

    reg ?
    {
      field: '',
      header: 'Recibido FIN',
      className: "small",
      Format: "Template",
      align: "center",
      frozen: "true",
      alignFrozen: "right",
      filter: false,
      hidden: [1,36].includes(userAuth?.IdRol), //Roles Admin, finanzas
      body: (rowData) =>  rowData?.IdIngreso && (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Checkbox 
          onChange={(e) => {
            changeRecibidoFinanzas(rowData, e.checked)}
          }
          disabled={[75,76].includes(rowData?.IdEstadoRevisado)}
          checked={[74,75].includes(rowData?.IdEstadoRevisado)}
        />
      </div>
      ),
    }: null,

    reg ?
    {
      field: '',
      header: 'Revisado',
      className: "small",
      Format: "Template",
      align: "center",
      frozen: "true",
      alignFrozen: "right",
      filter: false,
      hidden: [1,36].includes(userAuth?.IdRol), //Roles Admin, finanzas
      body: (rowData) =>  rowData?.IdIngreso && (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Checkbox 
          // onChange={(e) => {
          //   changeRevisado(rowData, e.checked)}
          // }
          // disabled={[73,76].includes(rowData?.IdEstadoRevisado)}
          disabled={true}
          checked={[75].includes(rowData?.IdEstadoRevisado)}
        />
      </div>
      ),
    }: null,
  ];

  const table = {
    Columns: columns,
    Data: listadoEnc,
    fileName: "Ingresos Bodega" + new Date().toDateString(),
    loading: loading,
    clases: "tablaListados alturaListado60",
    showModal: (e) => showModal(e),
    key: "IdIngreso",
    selected: selectedDetalle,
    setSelected: (e) => setSelectedDetalle(e),
  };

  const showModal = () => {
    setShowDialog(true); 

  };  

  const Ingreso = (Id) => {
    setIngresoEdit(Id);
    setShowDialog(true);
  };



  return (
    <div>
      <Toast ref={toast} />
      <div style={{ height: "82vh" }}>
        <AgGrid table={table} />
      </div>
    </div>
  );
};

export default ListadoIngresosBodega;
